import { v4 } from "uuid";
import { create } from "zustand";

type LoggerStore = {
  initialised: boolean;
  sessionId: string;
  interactionId: string;
  changeInteraction: (override?: { sessionId: string; interactionId: string }) => void;
  setInitialised: () => void;
};

export const useLoggerStore = create<LoggerStore>((set) => ({
  initialised: false,
  interactionId: v4(),
  sessionId: v4(),
  changeInteraction: (override) => {
    if (override?.sessionId) {
      set(() => ({ sessionId: override.sessionId }));
    }
    set(() => ({ interactionId: override?.interactionId ?? v4() }));
  },
  setInitialised: () => {
    set(() => ({ initialised: true }));
  },
}));
